import React from 'react';
import clsx from 'clsx';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { ExcerptCardProps, ExcerptItems } from '@/components/card/types';
import { Link } from '@/components/link/Link';
import { CustomLinkProps } from '@/components/link/types';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import { Headline } from '@/components/headline/Headline';
import { renameDomProps } from '@/utils/sanitizeDomProps';

const ExcerptCard: React.FC<ExcerptCardProps> = React.memo(
  ({ title, description, items, link, className, ...rest }) => {
    const renamedProps = renameDomProps(rest);
    return (
      <div
        className={clsx(
          'excerpt-card flex flex-col gap-4 rounded-xl border border-stone-200 bg-white p-6 text-brand-700',
          className,
        )}
        {...renamedProps}
      >
        <h3 className="text-xl font-semibold">{title}</h3>
        <div className="excerpt-card-description">
          {description && <SerializeDescription description={description} />}
        </div>
        <div className="excerpt-items grid divide-y divide-solid divide-stone-300">
          {items.map((item: ExcerptItems, index: number) => (
            <div
              key={index}
              className="excerpt-item flex flex-row gap-4 py-6 last-of-type:pb-0"
            >
              {item.image && (
                <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-full">
                  <BaseImage
                    {...item.image}
                    className="h-full w-full"
                    sizes="48px"
                  />
                </div>
              )}

              <div className="flex flex-col gap-1">
                <div className="flex flex-col">
                  <Headline {...item.headline}>{item.headline.title}</Headline>
                  <div
                    className={
                      'cta-mini-card-description excerpt-card-description'
                    }
                  >
                    <SerializeDescription description={item.description} />
                  </div>
                </div>

                {item.links?.length && (
                  <div className="gap mt-2 flex flex-col gap-1">
                    {item.links.map(
                      (link: CustomLinkProps, linkIndex: number) => (
                        <Link key={linkIndex} {...link}>
                          {link.title}
                        </Link>
                      ),
                    )}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        {link?.href && (
          <div className="flex">
            <Link {...link} />
          </div>
        )}
      </div>
    );
  },
);

ExcerptCard.displayName = 'ExcerptCard';
export default ExcerptCard;
